import { TS_Deposit }           from '../TravelSeller/Models/TS_Deposit';
import { BookingItemInterface } from './BookingItemInterface';

export class Deposit extends TS_Deposit implements BookingItemInterface {
}